import { useState } from 'react';
import { BASE_URL, CREATE_CLIENT_SELF_ONBOARDING } from "../utility/constants";
import { axiosInstance } from "../services/axiosConfig";

const useCreateClientSelfOnboarding = () => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const API_URL = `${BASE_URL}${CREATE_CLIENT_SELF_ONBOARDING}`;

    const createClient = async (clientName, clientEmail, phoneNumber, organizationName, websiteUrl) => {
        setIsLoading(true);
        const requestBody = {
            name: clientName,
            email: clientEmail,
            organisation_name: organizationName,
            phone: phoneNumber,
            website_url: websiteUrl
        };

        try {
            const res = await axiosInstance.post(API_URL, requestBody);
            setResponse(res.data);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return { response, error, isLoading, createClient };
};

export default useCreateClientSelfOnboarding; 